import React, { useState, useEffect } from 'react';
import { AutoHedgeConnect } from './AutoHedgeConnect';
import { AutoHedgeDashboard } from './AutoHedgeDashboard';
import { useAutoHedgeContext } from '../contexts/AutoHedgeContext';

export const AutoHedgeModal = ({ isOpen, onClose }) => {
  const { connectedAccounts, resetAccounts } = useAutoHedgeContext();
  const [showDashboard, setShowDashboard] = useState(false);

  console.log('🛡️ AutoHedgeModal RENDER (Context):', {
    isOpen,
    connectedAccountsCount: connectedAccounts?.length || 0,
    showDashboard,
    connectedAccounts: connectedAccounts
  });

  // Monitor connected accounts changes
  useEffect(() => {
    console.log('🛡️ AutoHedgeModal: connectedAccounts changed (Context)', {
      count: connectedAccounts?.length || 0,
      accounts: connectedAccounts
    });

    if (connectedAccounts && connectedAccounts.length > 0) {
      console.log('🏛️ AUTO HEDGE (Context): Account detected, switching to dashboard...');
      setShowDashboard(true);
    } else {
      console.log('🏛️ AUTO HEDGE (Context): No accounts, showing connect screen');
      setShowDashboard(false);
    }
  }, [connectedAccounts]);

  // Reset when modal closes
  useEffect(() => {
    if (!isOpen) {
      console.log('🛡️ AUTO HEDGE (Context): Modal closed, resetting');
      setShowDashboard(false);
      resetAccounts(); // Reset connected accounts when modal closes
    }
  }, [isOpen, resetAccounts]);

  // Force reset when modal opens to ensure clean state
  useEffect(() => {
    if (isOpen) {
      console.log('🛡️ AUTO HEDGE (Context): Modal opened, ensuring clean state');
      setShowDashboard(false);
      resetAccounts(); // Reset to ensure we start with connect screen
    }
  }, [isOpen, resetAccounts]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-atticus-navy-900 rounded-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto border border-atticus-navy-700">
        {/* Modal Header */}
        <div className="flex items-center justify-between p-6 border-b border-atticus-navy-700">
          <div className="flex items-center space-x-3">
            <span className="text-2xl">🛡️</span>
            <h2 className="text-white text-2xl font-bold">Auto Hedge</h2>
            {showDashboard && (
              <span className="bg-green-500/20 text-green-400 px-3 py-1 rounded-full text-sm font-medium">
                Connected ({connectedAccounts?.length || 0})
              </span>
            )}
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Modal Content */}
        <div className="p-6">
          {showDashboard ? (
            <div>
              <div className="bg-green-500/20 border border-green-500/50 rounded-lg p-3 mb-4">
                <div className="text-green-400 text-sm font-medium">
                  ✅ Dashboard View - {connectedAccounts?.length || 0} account(s) connected via Context
                </div>
              </div>
              <AutoHedgeDashboard />
            </div>
          ) : (
            <div>
              <div className="bg-blue-500/20 border border-blue-500/50 rounded-lg p-3 mb-4">
                <div className="text-blue-400 text-sm font-medium">
                  🔗 Connect View - No accounts connected
                </div>
              </div>
              <AutoHedgeConnect />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
